import { CommerceService } from "@/services/commerce"

/**
 * If triggered more than once (custom type exists, error will be returned)
 *
 * Kept here to track progress and for future migrations.
 * Purpose to add custom fields for customer that is adm in commercetools
 */
export const mutationAddCustomAdmUserType = {
  async addCustomAdmUserType(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const typeDraft = {
      key: "admCustomTypeKey",
      name: { "de-DE": "admCustomTypeName", "en-US": "admCustomTypeName" },
      description: {
        "de-DE": "Benutzerdefinierte Felder für adm-Benutzer",
        "en-US": "Custom fields for adm user",
      },
      resourceTypeIds: ["customer"],
      fieldDefinitions: [
        {
          type: { name: "String" },
          name: "employeeNumber",
          label: {
            "de-DE": "Mitarbeiternummer",
            "en-US": "Employee number",
          },
          required: false,
        },
        {
          type: {
            name: "Set",
            elementType: {
              name: "String",
            },
          },
          name: "regionalLeadNumbers",
          label: {
            "de-DE": "Regionalleiternummern",
            "en-US": "Regional Lead Numbers",
          },
          required: false,
        },
        {
          type: {
            name: "Set",
            elementType: {
              name: "String",
            },
          },
          name: "admNumbers",
          label: {
            "de-DE": "Kundenkreisnummern (ADM Nummern)",
            "en-US": "ADM Numbers",
          },
          required: false,
        },
        {
          type: {
            name: "Set",
            elementType: {
              name: "String",
            },
          },
          name: "regionalLeadExcludedCustomerGroups",
          label: {
            "de-DE": "Ausgeschlossene Kundenkreisnummern",
            "en-US": "Regional Lead Excluded Customer Groups",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "allowReservationMutation",
          label: {
            "de-DE": "Kennzeichen, ob die Mutation der Reservierung erlaubt ist",
            "en-US": "Indicator if reservation mutation is allowed",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "allowAllCustomerSearch",
          label: {
            "de-DE": "Kennzeichen, ob die Suche nach allen Kunden erlaubt ist",
            "en-US": "Indicator if all customer search is allowed",
          },
          required: false,
        },
        {
          type: { name: "String" },
          name: "printAdmNumber",
          label: {
            "de-DE": "Druck-Verkäufer-Nr.",
            "en-US": "Seller no. for printing",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "allowDocumentMutation",
          label: {
            "de-DE": "Kennzeichen, ob die Mutation der Dokuments erlaubt ist",
            "en-US": "Indicator if document mutation is allowed",
          },
          required: false,
        },
        {
          type: { name: "Boolean" },
          name: "enableAssistant",
          label: {
            "de-DE": "Kennzeichen, ob der digitale Assistent aktiviert ist",
            "en-US": "Indicator if digital assistant is enabled",
          },
          required: false,
        },
      ],
    }

    try {
      await commerceApi.types().post({ body: typeDraft }).execute()

      return true
    } catch (error) {
      throw new Error(error)
    }
  },
}
